import { HttpService } from '@Services/index';
import { useMutation } from '@tanstack/react-query';
import { useBoundStore } from '@Store/useBoundStore';

interface SetPasswordRequest {
  password: string;
}
export interface SetPasswordResponse {
  token: string;
}

export const setAuthorizedUserPassword = async (data: SetPasswordRequest) => {
  const { customerId, authorizedUserId } = useBoundStore.getState().onboardingSlice;
  const token = useBoundStore.getState().getAuthUserAccessToken();

  const url = `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/password`;

  const res = await HttpService.post<SetPasswordResponse>(url, {
    setPasswordData: {
      password: data.password,
    },
    token,
  });

  return res.data;
};

export const useSetAuthorizedUserPassword = () =>
  useMutation({
    mutationFn: setAuthorizedUserPassword,
  });

export const completeOnboarding = async () => {
  const { customerId, authorizedUserId } = useBoundStore.getState().onboardingSlice;
  const token = useBoundStore.getState().getAuthUserAccessToken();
  const url = `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/complete`;
  await HttpService.post(url, {
    token,
  });
};

export const useCompleteOnboarding = () =>
  useMutation({
    mutationFn: completeOnboarding,
  });
